export default __webpack_public_path__ + "static/media/shafath-party.4a73f0c6.gif";